module.exports = __webpack_public_path__ + "static/img/3.70f9a6f2.jpg";